module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0